import {
    WGCWX_LEADERBOARDS_REQUEST,
    WGCWX_LEADERBOARDS_SUCCESS,
    WGCWX_LEADERBOARDS_ERROR,
    WGCWX_LEADERBOARDS_GET_REWARDS_REQUEST,
    WGCWX_LEADERBOARDS_GET_REWARDS_SUCCESS,
    WGCWX_LEADERBOARDS_GET_REWARDS_ERROR,
} from 'state/actions/wgcwx_leaderboards'

import { ERROR_ACTION_TYPE } from 'containers/WGCWXLeaderboards/constants'

const defaultState = {
    isLoading: true,
    errorMessage: null,
    errorActionType: null,
    isRewardsProcessing: false,
    isRewardsTaken: false,
    leaderboards: {},
}

export default function reducer(state = defaultState, action) {
    switch (action.type) {
    case WGCWX_LEADERBOARDS_REQUEST: {
        return {
            ...state,
            isLoading: true,
            errorMessage: null,
            isRewardsTaken: false,
        }
    }
    case WGCWX_LEADERBOARDS_SUCCESS: {
        return {
            ...state,
            isLoading: false,
            leaderboards: action.payload.leaderboards,
        }
    }
    case WGCWX_LEADERBOARDS_ERROR: {
        return {
            ...state,
            isLoading: true,
            errorMessage: action.payload.errorMessage,
            errorActionType: ERROR_ACTION_TYPE.LEADERBOARDS_ERROR,
        }
    }
    case WGCWX_LEADERBOARDS_GET_REWARDS_REQUEST: {
        return {
            ...state,
            isRewardsProcessing: true,
        }
    }
    case WGCWX_LEADERBOARDS_GET_REWARDS_SUCCESS: {
        return {
            ...state,
            isRewardsProcessing: false,
            isRewardsTaken: true,
        }
    }
    case WGCWX_LEADERBOARDS_GET_REWARDS_ERROR: {
        return {
            ...state,
            isRewardsProcessing: false,
            errorMessage: action.payload.errorMessage,
            errorActionType: ERROR_ACTION_TYPE.GET_REWARDS_ERROR,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/wgcwx_leaderboards.js